import Papa from "papaparse";
import * as XLSX from "xlsx";

export const parseFile = async (file) => {
  const ext = file.name.split(".").pop();

  if (ext === "csv") {
    return new Promise((resolve) => {
      Papa.parse(file, {
        header: true,
        complete: (res) => resolve(res.data),
      });
    });
  }

  const buffer = await file.arrayBuffer();
  const wb = XLSX.read(buffer);
  const sheet = wb.Sheets[wb.SheetNames[0]];
  return XLSX.utils.sheet_to_json(sheet);
};